import React, {useEffect, useRef, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';

import {setLookContextMenu} from "../../../actions/lookFunctions";

import ContextMenuQKBButtons from "./contextMenuQKBButtons";

// export const checkForContextMenuCommon = (partId, layerPosition) => {
export const checkForContextMenuCommon = () => {
  const returnObject = {
    allButtons: [], // {partId: "", translateId: "", isWizard: true, wizardId: sting|number, hasSubMenu: false}
    showButtons: []  // {partId: "", translateId: "", isWizard: true, wizardId: sting|number, hasSubMenu: false}
  }
  return returnObject
}

const getContextMenuPosition = (contextMenu, position, isMobile) => {
  const {partId, layerPosition} = contextMenu;
  const {showButtons} = checkForContextMenuCommon(partId, layerPosition);

  let left = isMobile ? '50%' : position.x - 50;
  let top = isMobile ? '50%' : position.y - 50;
  let right = 'auto';

  const maxAllowedWidth = showButtons.length > 2 ? 300 : 210;

  let maxAllowedHeight = 110;
  if (showButtons.length > 6) {
    maxAllowedHeight = 330;
  } else if (showButtons.length >= 3) {
    maxAllowedHeight = 220;
  }
  if (!isMobile && (left > window.innerWidth - maxAllowedWidth)) {
    left = 'auto';
    right = 0
  }
  if (!isMobile && (top > window.innerHeight - maxAllowedHeight)) {
    let negativeMargin = 50;
    if (showButtons.length > 6) {
      negativeMargin = 250;
    } else if (showButtons.length >= 3) {
      negativeMargin = 150;
    }
    top = top - negativeMargin;
  }

  return {left, top, right}
}

const ContextMenuQKB = (props) => {

  const {contextMenu, setLookContextMenu, isMobile, handleContextMenuClick, renderGreenLayerByZindex} = props;
  const {opened, position} = contextMenu;
  const [styles, setStyles] = useState({left: 0, top: 0, right: 0});
  const [buttons, setButtons] = useState([]);
  const anchorRef = useRef(null);

  const handleClose = (event) => {
    if (document.hoveredLayer && event.target.closest(".canvas-el") && ALL_CONTEXT_MENU.includes(document.hoveredLayer.partId)) {
      return
    }
    setLookContextMenu({
      opened: false,
      layerPosition: "",
    });
  };

  useEffect(() => {
    if (!contextMenu.opened) {
      return null
    }
    setStyles(getContextMenuPosition(contextMenu, position, isMobile));
    const {showButtons} = checkForContextMenuCommon(contextMenu.partId, contextMenu.layerPosition);
    setButtons(showButtons);
  }, [contextMenu, position, isMobile]);

  // console.log("styles", styles);

  let contextStyles = styles;
  if (buttons.length <= 4) {
    contextStyles = Object.assign({}, styles, {maxWidth: "210px"});
  }

  return (
    <div style={contextStyles} className="contextQKB" ref={anchorRef}>
      <Popper open={opened}
              className={isMobile ? "contextQKB-mobile" : "contextQKB-popper"}
              anchorEl={anchorRef.current}
              placement={"bottom-start"}
              transition
              disablePortal={!isMobile}
              modifiers={[{
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: true,
                  tether: true,
                  rootBoundary: 'viewport',
                  padding: 8,
                },
              },]}>
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: "left top" }}
          >
            <div className="">
              <ClickAwayListener onClickAway={handleClose}>
                <div className="">
                  <ContextMenuQKBButtons buttons={buttons}
                                         setButtons={setButtons}
                                         renderGreenLayerByZindex={renderGreenLayerByZindex}
                                         handleContextMenuClick={handleContextMenuClick}/>
                </div>
              </ClickAwayListener>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  )
};

ContextMenuQKB.propTypes = {
  handleContextMenuClick: PropTypes.func,
  renderGreenLayerByZindex: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    contextMenu,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookContextMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenuQKB)
